import _ from 'lodash';
import { useState, useCallback } from 'react';

import FilterData from 'src/models/recipe/list/filter-data';

// ----------------------------------------------------------------------

type FilterFields = Record<string, unknown>;

type Options = {
  onPageReset: () => void;
};

export function useRecipeBrowseFilters(defaultFilterFields: FilterFields | null, { onPageReset }: Options) {
  const [filters, setFilters] = useState<FilterData>(new FilterData(defaultFilterFields));
  const [bucketFilters, setBucketFilters] = useState<FilterData>(new FilterData());

  const handleFilters = useCallback((name: string, value: unknown) => {
    setFilters((prev) => new FilterData({ ...prev.getFilterFields(), [name]: value }));
    onPageReset();
  }, [onPageReset]);

  const handleRemoveFilter = useCallback((name: string) => {
    setFilters((prev) => new FilterData(_.omit(prev.getFilterFields(), name)));
    onPageReset();
  }, [onPageReset]);

  const handleBucketSearch = useCallback((name: string, value: unknown) => {
    setBucketFilters((prev) => new FilterData({ ...prev.getFilterFields(), [name]: value }));
  }, []);

  const handleResetFilters = useCallback(() => {
    setFilters(new FilterData({}));
    onPageReset();
  }, [onPageReset]);

  const handleSearch = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    handleFilters('search', event.target.value);
  }, [handleFilters]);

  return {
    filters,
    bucketFilters,
    canReset: filters.canReset(),
    handleFilters,
    handleRemoveFilter,
    handleBucketSearch,
    handleResetFilters,
    handleSearch,
  };
}
